export default __webpack_public_path__ + "static/media/docs-stress-compensation-arrows.dfc77865.png";